import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Image from '../../components/ContentfulImage';
import Markdown from '../../components/Markdown';
import Placeholder from '../../components/Placeholder';
import media from '../../styles/media.style';
import { MOBILE_PADDING, PAGE_WIDTH } from '../../styles/variables.style';

const Section = styled.section`
  margin: 0 auto;
  max-width: ${PAGE_WIDTH}px;
  padding: ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletL`
    display: flex;
    flex-direction: ${({ index }) => (index % 2 === 0 ? 'row' : 'row-reverse')};
    justify-content: space-between;
    margin-top: ${({ index }) => (index === 0 ? '100px' : 'unset')};
    padding: 100px 0;
    position: relative;
  `};

  ${media.desktop`
    margin-top: ${({ index }) => (index === 0 ? '200px' : 'unset')};
    padding: 120px 0;
  `};
`;

const PrimaryImageContainer = styled.div`
  ${media.tabletL`
    width: 50%;
  `};
`;

const SecondaryImageContainer = styled.div`
  margin: 0 auto;
  max-height: 380px;
  max-width: 380px;
  padding: 20px;
  width: 50%;

  ${media.tabletL`
    background-color: white;
    height: 260px;
    left: 50%;
    padding: 30px;
    position: absolute;
    top: 0;
    transform: translate(-50%, -50%);
    width: 260px;
    z-index: 10;
  `};

  ${media.desktop`
    height: 380px;
    padding: 40px;
    width: 380px;
  `};
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 30px;

  ${media.tabletL`
    margin-top: 0;
    padding: 60px 40px;
    width: 50%;
  `};

  ${media.desktop`
    padding: 100px;
  `};
`;

const Title = styled.div`
  font-size: 24px;

  ${media.tabletL`
    font-size: 34px;
  `};

  ${media.desktop`
    font-size: 44px;
  `};
`;

const Description = styled.div`
  margin-top: 20px;

  ${media.tabletL`
    margin-top: 30px;
  `};

  p {
    font-size: 14px;

    ${media.desktop`
      font-size: 16px;
    `};

    &:first-child {
      margin-top: 0;
    }
  }
`;

const OverviewSection = ({ title, description, primaryImage, secondaryImage, index }) => (
  <Section index={index}>
    <SecondaryImageContainer>
      {secondaryImage ? <Image src={secondaryImage} options={{ size: 300 }} /> : <Placeholder w="100%" pb="100%" />}
    </SecondaryImageContainer>

    <PrimaryImageContainer>
      {primaryImage ? (
        <Image src={primaryImage} options={{ size: [720] }} />
      ) : (
        <Placeholder w="100%" pb="calc(1000% / 9)" />
      )}
    </PrimaryImageContainer>

    <Details>
      <Title>{title || <Placeholder w="60%" pb="20%" />}</Title>
      {description ? (
        <Markdown src={description} Component={Description} />
      ) : (
        <Description>
          <Placeholder w="100%" pb="40%" />
        </Description>
      )}
    </Details>
  </Section>
);

OverviewSection.defaultProps = {
  title: undefined,
  description: undefined,
  primaryImage: undefined,
  secondaryImage: undefined,
};

OverviewSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  primaryImage: PropTypes.shape(),
  secondaryImage: PropTypes.shape(),
  index: PropTypes.number.isRequired,
};

export default OverviewSection;



// WEBPACK FOOTER //
// ./src/pages/OurAssetsPage/AssetSection.js